import { render, staticRenderFns } from "./order-surcharge-modal-component.vue?vue&type=template&id=5ec4759f&scoped=true"
import script from "./order-surcharge-modal-component.vue?vue&type=script&lang=js"
export * from "./order-surcharge-modal-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4759f",
  null
  
)

export default component.exports